import React from 'react';

import { Link } from 'react-router-dom';

import SvgEmChord from '~svg/SvgEmChord';

const ChordsButton = () => (
	<Link className="button chords-button" style={buttonStyle} to="/chords">
		<SvgEmChord style={iconStyle} />
		Chords
	</Link>
);

const buttonStyle: React.CSSProperties = {
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	textDecoration: 'none',
};

const iconStyle: React.CSSProperties = {
	height: 20,
	width: 20,
};

export default ChordsButton;
